import { render, staticRenderFns } from "./SculpturesPdf.vue?vue&type=template&id=dadde528&scoped=true&"
import script from "./SculpturesPdf.vue?vue&type=script&lang=js&"
export * from "./SculpturesPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dadde528",
  null
  
)

export default component.exports